module.exports = __webpack_public_path__ + "static/img/animation_200.6635fe8.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/animation_200.gif
// module id = wzNO
// module chunks = 1